export default {"src":"/_next/static/media/butterfly2.f1268de8.svg","height":133,"width":102,"blurWidth":0,"blurHeight":0};